import { render, staticRenderFns } from "./OnboardingStepName.vue?vue&type=template&id=e511d69e"
import script from "./OnboardingStepName.vue?vue&type=script&lang=js"
export * from "./OnboardingStepName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports